import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { settings } from '../../../app.settings';
import { DialogOfferQuickeditComponent } from '../../../shared/components/dialog-offer-quickedit/dialog-offer-quickedit.component';
import { AuthService } from 'app/auth/services/auth.service';
import { dayDiff } from '../../../shared/utils/dates';

@Component({
  selector: 'app-offer-table',
  templateUrl: './offer-table.component.html',
  styleUrls: ['./offer-table.component.sass']
})
export class OfferTableComponent implements OnInit {
  @Input() offers: any = [];
  @Input() page = 1;
  @Input() total = 0;
  @Input() ordering: string;
  @Input() filters: any = {};
  @Input() perPage = settings.pagination.perPage;
  @Output() pageChange = new EventEmitter();
  @Output() filtersChange = new EventEmitter();
  @Output() orderingChange = new EventEmitter();

  paginationSettings = {};
  hasSegments = false;
  hasLbs = false;

  constructor(
    private authService: AuthService,
    public confirmDialog: MatDialog
  ) { }

  ngOnInit() {
    this.paginationSettings = {
      itemsPerPage: this.perPage,
      currentPage: this.page,
      totalItems: this.total || (this.offers || []).length
    };

    this.authService.getAuthenticatedUser().subscribe((response: any) => {
      if (response) {
        this.hasSegments = response.program?.configuration?.has_segments;
        this.hasLbs = response.program?.configuration?.has_lbs;
      }
    });
  }

  getOrderingClass(col: string) {
    return {
      'table-order': this.ordering === col || this.ordering === '-' + col,
      'reverse': this.ordering === '-' + col
    };
  }

  onOrderBy(col: string) {
    this.orderingChange.emit(col === this.ordering ? '-' + col : col);
  }

  onPageChange($event: any) {
    this.pageChange.emit($event);
  }

  onTermChange($event: any) {
    this.filters.term = $event;
    this.filtersChange.emit(this.filters);
  }

  onStartDateChange($event: any) {
    this.filters.start_date = $event;
    this.filtersChange.emit(this.filters);
  }

  onEndDateChange($event: any) {
    this.filters.end_date = $event;
    this.filtersChange.emit(this.filters);
  }

  onOpenOfferQuickeditor(offer: any) {
    this.confirmDialog.open(DialogOfferQuickeditComponent, {
      width: '450px',
      data: {
        offer: offer
      }
    });
  }

  computeRemainingDays(offer) {
    if (offer.end_date) {
      return dayDiff(new Date(offer.end_date), new Date);
    }
  }

  isHighlighted(offer) {
    return offer.type === 'CASHBACK' && ['ACTIVE', 'PUBLISHED'].includes(offer.status) && !offer.cashback_rate;
  }

  isOfferEnded(offer) {
    return this.isNotEditable(offer)
  }

  isNotEditable(offer) {
    return ['ENDED', 'DEACTIVATED', 'COMPLETED'].includes(offer.status);
  }

  getPreviewRouterLink(offer: any) {
    return ['/offers/', offer.id];
  }

  getEditRouterLink(offer: any) {
    switch (offer.type) {
      case 'UNIQUE_COUPON':
        return ['/coupons/unique/edit', offer.id];

      case 'GENERIC_COUPON':
        return ['/coupons/generic/edit', offer.id];

      default:
        return ['/offers/', offer.id];
    }
  }
}
